import { t } from "@/lib/i18n"

export type ExtraGroupRules = { minSelect: number; maxSelect: number | null }

// A group's own selections must satisfy its min/max before an order (or the
// item drawer's group attachment) is considered complete. Shared by the staff
// management workspace, the group-aware order forms, and the diner dish detail.
export function groupSelectionValid(group: ExtraGroupRules, selectedCount: number): boolean {
  if (selectedCount < group.minSelect) return false
  if (group.maxSelect != null && selectedCount > group.maxSelect) return false
  return true
}

// Single source of truth for how a group's min/max selection rules read as
// prose ("Choose between 1 and 3", "Optional, up to 2"). Shared by both the
// staff surfaces and the diner dish detail so the two sides never drift.
export function groupRuleSummary(group: ExtraGroupRules): string {
  const max = group.maxSelect

  if (group.minSelect === 0 && max == null) {
    return t("ui.extras.rule_optional")
  }
  if (group.minSelect === 0 && max != null) {
    return t("ui.extras.rule_optional_up_to", { max })
  }
  if (max != null && group.minSelect === max) {
    return t("ui.extras.rule_exact", { count: group.minSelect })
  }
  // min > 0 with no ceiling: an open-ended minimum reads as "at least N", not a
  // range with a "∞" placeholder standing in for the missing max.
  if (max == null) {
    return t("ui.extras.rule_at_least", { min: group.minSelect })
  }
  return t("ui.extras.rule_range", { min: group.minSelect, max })
}
